const PbxxRecord = require('../pbxx_record')
const _ = require('lodash')

module.exports = class ShareSetting extends PbxxRecord {
  static get class_name() {
    return 'ShareSetting'
  }

  update_crop(crop_attributes) {
    return this._mapper().update_crop(this.id, {
      data: crop_attributes
    }).then((response) => {
      return this.crop_attributes = response.data
    }, (error) => {
      throw(error)
    })
  }

  get is_valid() {
  	return this.name && this.name.length && this.message && this.message.length
  }

  get is_link_share() {
    return this.post_format === 'link'
  }

  get is_photo_share() {
    return this.post_format === 'photo'
  }

  get is_video_share() {
    return this.post_format === 'video'
  }

  get get_digital_asset() {
    return this.digital_assets && this.digital_assets.length ? _.last(this.digital_assets) : null
  }

}
